module.exports = __webpack_public_path__ + "img/boxbg.eeddcfc7.jpg";